import { Row } from 'antd';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Modal } from 'components/atoms/modal';

export const StyledModal = styled(Modal)`
  height: 800px;
  top: var(--layout-02);
  color: var(--black-100);

  .ant-modal-body {
    background: var(--coolest-gray-10);
    height: 585px;
    overflow-y: auto;
    padding-bottom: var(--layout-04);
  }

  .ant-modal-footer {
    padding: var(--spacing-05);
  }
`;

export const TitleWrapper = styled.div`
  padding: var(--spacing-03) 0 var(--spacing-03) var(--spacing-07);
`;

export const ModalContent = styled.div`
  padding: var(--spacing-07) var(--layout-06) var(--spacing-06) var(--layout-05);
  font-size: var(--heading-6-size);
  line-height: var(--heading-6-line-height);
`;

export const Card = styled.div`
  height: 136px;
  padding: var(--spacing-06);
  background: var(--white-100);
  box-shadow: var(--shadow-02);

  .card-content {
    margin-top: var(--spacing-03);
    font-size: var(--font-size-sm);
    line-height: var(--line-height-code-01);
    color: var(--gray-80);
  }

  &.things-to-remember-card {
    .card-title {
      font-size: var(--heading-4-size);
      font-weight: 300;
      margin-bottom: var(--spacing-07);
      color: var(--gray-30);
    }
  }
`;

export const CardWrapper = styled(Row)`
  margin-top: var(--spacing-07);
`;

export const ConfirmButton = styled(Button)`
  margin-left: var(--spacing-05);
`;
